import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputFormTextField from 'components/atoms/GefMui/OutputFormTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import formDescriptorFn, {
	DOCUMENT_INFO_FORM_NAME,
	FIELDS,
} from 'features/views/productionControlDetail/documentInfo/form';
import { getProductionControlDetail } from 'features/views/productionControlDetail/selectors';

export const DocumentInfo = () => {
	const productionControlDetail = useSelector(getProductionControlDetail);

	return (
		<Stack spacing={2}>
			<SectionHeader text={getLabelMessage('productionControlDetail:documentInfo')} />
			<Form name={DOCUMENT_INFO_FORM_NAME} formDescriptorFn={formDescriptorFn}>
				<Grid container>
					<Grid size={12}>
						<Grid container spacing={2}>
							<Grid size={3}>
								<OutputFormTextField
									size="small"
									fieldName={FIELDS.policyNumber}
									label={getLabelMessage('productionControl:policyNumber')}
									fullWidth
									value={productionControlDetail?.policyNo}
									slotProps={{
										inputLabel: {
											shrink: !!productionControlDetail?.policyNo,
										},
									}}
								/>
							</Grid>
							<Grid size={3}>
								<OutputFormTextField
									size="small"
									fieldName={FIELDS.policyHolder}
									label={getLabelMessage('productionControlDetail:policyHolder')}
									fullWidth
									value={productionControlDetail?.policyHolder}
									slotProps={{
										inputLabel: {
											shrink: !!productionControlDetail?.policyHolder,
										},
									}}
								/>
							</Grid>
							<Grid size={6}>
								<OutputFormTextField
									size="small"
									fieldName={FIELDS.product}
									label={getLabelMessage('productionControl:product')}
									fullWidth
									value={productionControlDetail?.product}
									slotProps={{
										inputLabel: {
											shrink: !!productionControlDetail?.product,
										},
									}}
								/>
							</Grid>
							<Grid size={8}>
								<OutputFormTextField
									size="small"
									fieldName={FIELDS.documentUploadWave}
									label={getLabelMessage('productionControlDetail:documentUploadWave')}
									fullWidth
									value={productionControlDetail?.waveName}
									slotProps={{
										inputLabel: {
											shrink: !!productionControlDetail?.waveName,
										},
									}}
								/>
							</Grid>
							<Grid size={4}>
								<Grid
									container
									sx={{
										justifyContent: 'flex-end',
										alignItems: 'center',
									}}
								>
									<Typography sx={{ mx: 2 }} variant="body1">{`${getLabelMessage(
										'productionControlDetail:documentType',
									)}:`}</Typography>
									<Chip
										variant="filled"
										color="error"
										label={productionControlDetail?.documentTypeText}
									/>
								</Grid>
							</Grid>
							<Grid size={12}>
								<Alert severity="warning">
									{getLabelMessage('productionControlDetail:documentStateAlert')}
									<strong>{productionControlDetail?.documentStateText}</strong>
								</Alert>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Form>
		</Stack>
	);
};

export default DocumentInfo;
